export default {
  'active': 'Activa',
  'on-hold': 'Detenida',
  'cancelled': 'Anulada',
  'completed': 'Completada',
  'entered-in-error': 'Ingresada con error',
  'stopped': 'Expirada',
  'draft': 'Borrador',
  'unknown': 'Desconocido'
};
